Number.prototype.roundTo = function (decimals: number): number {
    const d = Math.pow(10, decimals);
    return Math.round((this + Number.EPSILON) * d) / d;
};
